export default __webpack_public_path__ + "static/media/host_btn_active.109813db.svg";